export default __webpack_public_path__ + "static/ScottTurlington-e5bc6d68f7132ece13b63c5dc8150d14.jpg";